<div class="main">
    <app-channel-slider [type]="'shows'" [header]="' '"></app-channel-slider>
</div>
